import { motion } from "framer-motion";
import { CheckCircle2, Database, GitBranch } from "lucide-react";
import type { WorkflowStepType } from "./WorkflowBuilder";

interface WorkflowStepProps {
  step: WorkflowStepType;
}

const WorkflowStep = ({ step }: WorkflowStepProps) => {
  const getStepIcon = () => {
    switch (step.type) {
      case "trigger":
        return GitBranch;
      case "action":
        return Database;
      case "condition":
        return CheckCircle2;
      default:
        return GitBranch;
    }
  };

  const Icon = step.icon || getStepIcon();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-start gap-4 bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="rounded-full p-2 bg-gradient-to-r from-primary/20 to-secondary/20">
        <Icon className="w-5 h-5 text-primary" />
      </div>
      <div className="flex-1">
        <h3 className="font-medium text-gray-900">{step.title}</h3>
        <p className="text-sm text-gray-500">{step.description}</p>
      </div>
    </motion.div>
  );
};

export default WorkflowStep;